/**
 * @name BirthdaysDialog
 * @description Modal de próximos cumpleaños
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { DataGrid } from '@components';
import { Icons, MUI } from '@styles';

const BirthdaysDialog = (props) => {
  const {
    birthdays,
    open,
    onClose
  } = props;

  const monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun',
    'jul', 'aug', 'sep', 'oct', 'nov', 'dec'
  ];

  const columns = [
    { type: 'complex', id: ['Foto', 'Nombres', 'Area'], label: i18n.t('GenericMessages.employee'), visible: true, filter: null },
    { id: 'Sucursal', label: i18n.t('GenericMessages.branch'), visible: true, filter: null, sort: true },
    { id: 'FechaNacimiento', label: i18n.t('GenericMessages.date'), visible: true, filter: 'BirthdayDateFilter', sort: false }
  ];

  const month = new Date().getMonth();

  return (
    <MUI.Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      disableBackdropClick
      disableEscapeKeyDown
    >
      <MUI.DialogTitle>
        {`${i18n.t('Home.birthdaysMonth')} ${i18n.t(`Months.${[monthNames[month]]}`)}`}
        <MUI.DialogBoxClose onClick={onClose}>
          <Icons.Close />
        </MUI.DialogBoxClose>
      </MUI.DialogTitle>
      <MUI.DialogContent>
        <MUI.Box padding="16px">
          <DataGrid
            canSort={true}
            columns={columns}
            rows={birthdays}
          />
        </MUI.Box>
      </MUI.DialogContent>
      <MUI.DialogActions>
        <MUI.ButtonText onClick={onClose}>
          {i18n.t('DialogConfirm.close')}
        </MUI.ButtonText>
      </MUI.DialogActions>
    </MUI.Dialog>
  );
};

BirthdaysDialog.propTypes = {
  // Array con la información de los cumpleaños del mes.
  birthdays: PropTypes.array.isRequired,
  // Boolean que indica si el modal esta abierto.
  open: PropTypes.bool.isRequired,
  // Función que se ejecuta para cerrar el modal.
  onClose: PropTypes.func.isRequired
};

export default BirthdaysDialog;